// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"281":"3ffda1cc","320":"32c9e697","367":"0f29b50c","840":"92739a11","960":"c9b577bb"}[chunkId] + ".js";
};